import React from 'react';
import { PERMISSION_LEVELS, PERMISSION_META } from './config';

/**
 * Segmented control for cycling through none / view / edit / delete.
 * Entirely keyboard-and-click friendly; replaces the old chip-cycle.
 */
const PermissionSegmented = ({ value = 'none', onChange, disabled }) => {
  return (
    <div
      role="radiogroup"
      aria-label="Permission level"
      className={`inline-flex rounded-md border border-gray-200 dark:border-gray-700 overflow-hidden ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
      data-testid="permission-segmented"
    >
      {PERMISSION_LEVELS.map((level) => {
        const isActive = value === level;
        const meta = PERMISSION_META[level];
        return (
          <button
            key={level}
            type="button"
            role="radio"
            aria-checked={isActive}
            disabled={disabled}
            onClick={() => !disabled && onChange(level)}
            title={meta.tooltip}
            data-testid={`perm-level-${level}`}
            className={`px-3 py-1.5 text-xs font-medium transition-colors ${isActive ? meta.activeColor : 'bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800'} ${disabled ? 'pointer-events-none' : ''}`}
          >
            {meta.label}
          </button>
        );
      })}
    </div>
  );
};

export default PermissionSegmented;
